import { GET_STATIC_CONTENT, SITE_LEISURE } from '@whitbread-eos/api';
import { useCustomLocale, useQueryRequest } from '@whitbread-eos/utils';
import ManageBookingModal from './ManageBookingModal.component';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ManageBookingModalContainer(_ref) {
  var onClose = _ref.onClose,
    isOpen = _ref.isOpen;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var _useQueryRequest = useQueryRequest(['GetStaticContent', language, country], GET_STATIC_CONTENT, {
      country,
      language,
      site: SITE_LEISURE,
      businessBooker: false
    }),
    labels = _useQueryRequest.data;
  return _jsx(ManageBookingModal, {
    labels: labels,
    onClose: onClose,
    isOpen: isOpen,
    baseTestId: "ManageBookingModal"
  });
}